export class ProductionOrder  {
  id:number;
  ordendeproduccion:string;
  ordendecompra:string;
  fechaordendecompra:Date;
  cliente:string;
  pais:string;
  contacto: string;
  cantidad:number;
  fechadespacho:Date;
  observaciones:string;
  estado:number;
  especificacion:string;
  is_generic:number

  constructor(id ,op,oc, fechaoc, cliente, pais, contacto, cantidad, fechaop, obs, estado,especificacion,generic){
    this.id = id;
    this.ordendeproduccion = op;
    this.ordendecompra = oc;
    this.fechaordendecompra = fechaoc;
    this.cliente = cliente;
    this.pais = pais;
    this.contacto = contacto;
    this.cantidad = cantidad;
    this.fechadespacho = fechaop;
    this.observaciones = obs;
    this.estado = estado;
    this.especificacion = especificacion;
    this.is_generic = generic == false ? 0 : 1;
  }


  public getJson(){
    let nul1 = '';
    let nul2 = '';
    let nul3 = '';
    if(this.ordendecompra != '' && this.ordendecompra != null){
      nul1 = `"purchase_order_number": "${this.ordendecompra}",`;
    }
    if(this.contacto != '' && this.contacto != null){
      nul2 = `"contact": "${this.contacto}",`;
    }
    if(this.observaciones != '' && this.observaciones != null){
      nul3 = `"comment": "${this.observaciones.replace(/\r?\n|\r/g, " ")}",`;
    }

    return `{
      "data":{
        "type": "production_orders",
        "id": "${this.id}",
        "attributes": {
          "id":"${this.id}",
          "number":"${this.ordendeproduccion}",
          `+nul1+`
          "purchase_order_date":"${this.fechaordendecompra}",
          "dispatch_date":"${this.fechadespacho}",
          `+nul3+`
          "status_id":"${this.estado}",
          "country_destination_id":"${this.pais}",
          "client_id":"${this.cliente}",
          "quantity":"${this.cantidad}",
          `+nul2+`
          "specification_id":"${this.especificacion}",
          "is_generic":"${this.is_generic}"
        }
      }
    }`;

  }

  public getJsonCerrarOP(id:number){
    return `{
      "data":{
        "type": "production_orders",
        "id": "${id}",
        "attributes": {
          "id":"${id}",
          "status_id":"2"
        }
      }
    }`;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/ProductionOrder.ts